type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export const EuroIcon: React.FC<Props> = ({ className, style }) => {
  return (
    <div className={className} style={style}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4274_52016)">
          <path
            d="M8.12012 3.62012C9.19012 3.62012 10.2005 4.00973 10.9805 4.71973C11.2904 4.99973 11.3103 5.47028 11.0303 5.78027C10.7503 6.09017 10.2797 6.11005 9.96973 5.83008C9.46975 5.3702 8.80979 5.12012 8.12988 5.12012H8.12012C7.18027 5.13014 6.3506 5.62002 5.85059 6.33984H9.12012C9.53007 6.33984 9.87003 6.67991 9.87012 7.08984C9.87012 7.49984 9.53012 7.83984 9.12012 7.83984H5.35059C5.35059 7.88984 5.33984 7.94023 5.33984 7.99023C5.33987 8.13015 5.35989 8.27046 5.37988 8.40039H7.75977C8.16977 8.40039 8.50977 8.74039 8.50977 9.15039C8.50955 9.56021 8.16963 9.90039 7.75977 9.90039H6.0498C6.55979 10.5003 7.27016 10.8799 8.12012 10.8799C8.97 10.8799 9.60022 10.4804 9.99023 10.1504C10.3102 9.88039 10.7798 9.92047 11.0498 10.2305C11.3197 10.5505 11.2797 11.0201 10.9697 11.29C10.1598 11.9899 9.14977 12.3799 8.12988 12.3799C6.44011 12.3798 4.98005 11.3602 4.29004 9.90039H3.69043C3.28056 9.90039 2.94065 9.56021 2.94043 9.15039C2.94043 8.74039 3.28043 8.40039 3.69043 8.40039H3.87988C3.86988 8.26039 3.83984 8.14 3.83984 8C3.83984 7.94 3.85059 7.88984 3.85059 7.83984H3.68066C3.27066 7.83984 2.93066 7.49984 2.93066 7.08984C2.93075 6.67991 3.27071 6.33984 3.68066 6.33984H4.15039C4.78044 4.76995 6.31043 3.64012 8.11035 3.62012H8.12012Z"
            fill="#00549F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0ZM8 1.5C4.42 1.5 1.5 4.42 1.5 8C1.5 11.58 4.42 14.5 8 14.5C11.58 14.5 14.5 11.58 14.5 8C14.5 4.42 11.58 1.5 8 1.5Z"
            fill="#00549F"
          />
        </g>
        <defs>
          <clipPath id="clip0_4274_52016">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
